export const LOAD_AI_PRODUCT_LIST = 'LOAD_AI_PRODUCT_LIST';
export const RENDER_AI_PRODUCT_LIST = 'RENDER_AI_PRODUCT_LIST';
export const RESET_AI_PRODUCT = 'RESET_AI_PRODUCT';
export const CREATE_AI_PRODUCT = 'CREATE_AI_PRODUCT';
export const PROCESS_AI_PRODUCT = 'PROCESS_AI_PRODUCT';
export const UPDATE_AI_PRODUCT = 'UPDATE_AI_PRODUCT';
export const DELETE_AI_PRODUCT = 'DELETE_AI_PRODUCT';
export const LOAD_AI_PRODUCT = 'LOAD_AI_PRODUCT';
export const RENDER_AI_PRODUCT = 'RENDER_AI_PRODUCT';
export const UPDATE_AI_PRODUCT_IMAGES = 'UPDATE_AI_PRODUCT_IMAGES';

export const SORTED_ID = 'SORTED_ID';

export function loadAiProductList() {
  return {
    type: LOAD_AI_PRODUCT_LIST,
  };
}

export function renderAiProductList(products) {
  return {
    type: RENDER_AI_PRODUCT_LIST,
    products,
  };
}

export function resetAiProduct() {
  return {
    type: RESET_AI_PRODUCT,
  };
}

export function createAiProduct(product, setError, onComplete) {
  return {
    type: CREATE_AI_PRODUCT,
    product,
    setError,
    onComplete,
  };
}

export function processAiProduct(id, config, setError) {
  return {
    type: PROCESS_AI_PRODUCT,
    id,
    config,
    setError,
  };
}

export function loadAiProduct(id) {
  return {
    type: LOAD_AI_PRODUCT,
    id,
  };
}

export function renderAiProduct(product) {
  return {
    type: RENDER_AI_PRODUCT,
    product,
  };
}

export function updateAiProduct(product, setError, onComplete) {
  return {
    type: UPDATE_AI_PRODUCT,
    product,
    setError,
    onComplete,
  };
}

export function deleteAiProduct(id) {
  return {
    type: DELETE_AI_PRODUCT,
    id,
  };
}

export function sortedId(value) {
  return {
    type: SORTED_ID,
    value,
  };
}

export function updateAiProductImages(images) {
  return {
    type: UPDATE_AI_PRODUCT_IMAGES,
    images,
  };
}
